import $ from 'jquery'

// The editors ask the server whether the text still fits the printed card every time a field
// changes, and the answers do not necessarily come back in the order they were asked: an answer
// for an older, shorter value can arrive last and hide an error that still applies. Every caller
// recomputes the whole field group before posting, so an outstanding request for the same key is
// always stale and is aborted rather than allowed to update the page.
const pending = {}

export default function postContentSize(key, url, data) {
  if (pending[key]) {
    pending[key].abort()
  }

  const request = $.post(url, data)
  pending[key] = request

  return request.always(function() {
    if (pending[key] === request) {
      delete pending[key]
    }
  })
}
